import React from "react"
import ArticlePage from "@Screens/Knowledge/Articles/ArticlesPage"

const TeamParole = (props) => {
    const { navigation } = props
    return <ArticlePage navigation={navigation} />
}

export default TeamParole
